// extracted by mini-css-extract-plugin
export default {"mainDiv":"styles_mainDiv__Nj5Sy"};